import { connect } from "react-redux";
import React from "react";
import { Facility, GritBatch } from "../../generated/client";
import { ErrorMessage, StoreState } from "../../types";
import Keycloak from 'keycloak-js';
import { Dispatch } from "redux"
import Api from "../../api";
import strings from "../../localization/strings";
import * as actions from "../../actions";
import { Navigate } from "react-router-dom";
import { Button, Confirm, Form, Grid, Input, InputOnChangeData, Loader } from "semantic-ui-react";
import { FormContainer } from "../FormContainer";
import { DateInput } from "semantic-ui-calendar-react";
import moment from "moment";


/**
 * Interface representing component properties
 */
interface Props {
  keycloak?: Keycloak;
  gritBatchId: string;
  gritBatch?: GritBatch;
  facility: Facility;
  onGritBatchSelected?: (gritBatch: GritBatch) => void;
  onGritBatchDeleted?: (gritBatchId: string) => void;
  onError: (error: ErrorMessage | undefined) => void;
}
/**
 * Interface representing component state
 */
interface State {
  gritBatch?: GritBatch;
  redirect: boolean;
  saving: boolean;
  messageVisible: boolean;
  open:boolean;
}
/**
 * React component for edit grit batch view
 */
class EditGritBatch extends React.Component<Props, State> {

  /**
   * Constructor
   *
   * @param props component properties
   */
  constructor(props: Props) {
    super(props);
    this.state = {
      redirect: false,
      gritBatch: undefined,
      saving: false,
      messageVisible: false,
      open:false
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
  }

  /**
   * Component did mount life-sycle method
   */
  public async componentDidMount() {
    const { keycloak, facility, onError, onGritBatchSelected } = this.props;
    try {
      if (!keycloak) {
        return;
      }
      const gritBatchesService = await Api.getGritBatchesService(keycloak);
      const gritBatch = await gritBatchesService.findGritBatch({
        gritBatchId: this.props.gritBatchId,
        facility: facility
      });
      onGritBatchSelected && onGritBatchSelected(gritBatch);
      this.setState({gritBatch: gritBatch});
    } catch (e: any) {
      Api.handleApiError(e, onError);
    }
  }

  /**
   * Handle form submit
   */
  private async handleSubmit() {
    const { keycloak, facility, onError, onGritBatchSelected } = this.props;
    try {
      if (!keycloak || !this.state.gritBatch) {
        return;
      }
      const gritBatchService = await Api.getGritBatchesService(keycloak);
      this.setState({saving: true});
      await gritBatchService.updateGritBatch({
        gritBatchId: this.state.gritBatch.id!,
        gritBatch: this.state.gritBatch,
        facility: facility
      });
      onGritBatchSelected && onGritBatchSelected(this.state.gritBatch);
      this.setState({saving: false});
      this.setState({messageVisible: true});
      this.setState({redirect: true});
      setTimeout(() => {
        this.setState({messageVisible: false});
      }, 3000);
    } catch (e: any) {
      Api.handleApiError(e, onError);
    }
  }

  /**
   * Handle gritBatch delete
   */
  private async handleDelete() {
    const { keycloak, facility, onError, onGritBatchDeleted } = this.props;
    try {
      if (!keycloak || !this.state.gritBatch) {
        return;
      }
      const gritBatchService = await Api.getGritBatchesService(keycloak);
      const id = this.state.gritBatch.id || "";
      await gritBatchService.deleteGritBatch({
        gritBatchId: id,
        facility: facility
      });
      onGritBatchDeleted && onGritBatchDeleted(id!);
      this.setState({redirect: true});
    } catch (e: any) {
      Api.handleApiError(e, onError);
    }
  }

  /**
   * Render edit seedBatch view
   */
  public render() {
    if (!this.state.gritBatch) {
      return (
        <Grid style={{paddingTop: "100px"}} centered>
          <Loader inline active size="medium" />
        </Grid>
      );
    }
    if (this.state.redirect) {
      return <Navigate to="/peatGritBatches" replace={true} />;
    }

    const deliveryDateText = moment(this.state.gritBatch?.deliveryDate).format("DD.MM.YYYY");

    return (
      <Grid>
        <Grid.Row className="content-page-header-row">
          <Grid.Column width={6}>
            <h2>{strings.gritBatchHeader}</h2>
          </Grid.Column>
          <Grid.Column width={3} floated="right">
            <Button className="danger-button" onClick={()=>this.setState({open:true})}>{strings.delete}</Button>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={8}>
            <FormContainer>
              <Form.Field required>
                <label>{ strings.amount }</label>
                <Input
                  type="number"
                  step="0.01"
                  value={ this.state.gritBatch?.amount }
                  onChange={ this.onAmountChange }
                />
              </Form.Field>
              <Form.Field required>
                <label>{ strings.batchNumber }</label>
                <Input
                  value={ this.state.gritBatch?.batchNumber }
                  onChange={ this.onBatchNumberChange }
                />
              </Form.Field>
              <Form.Field required>
                <label>{ strings.supplier }</label>
                <Input
                  value={ this.state.gritBatch?.supplier }
                  onChange={ this.onSupplierChange }
                />
              </Form.Field>
              <Form.Field required>
                <label>{ strings.deliveryDate }</label>
                <DateInput
                  dateFormat="DD.MM.YYYY"
                  onChange={ this.onDeliveryDateChange }
                  localStartization="fi-FI"
                  value={ deliveryDateText }
                />
              </Form.Field>
              <Button
              className="submit-button"
              onClick={this.handleSubmit}
              type='submit'
              loading={this.state.saving}
            >
              {strings.save}
            </Button>
            </FormContainer>
          </Grid.Column>
        </Grid.Row>
        <Confirm open={this.state.open} size={"mini"} content={strings.deleteConfirmationText +this.state.gritBatch!.batchNumber } onCancel={()=>this.setState({open:false})} onConfirm={this.handleDelete} />
      </Grid>
    );
  }

  /**
   * Updates batch number
   */
  private onBatchNumberChange = async (e: any, { value }: InputOnChangeData) => {
    this.setState({gritBatch: {...this.state.gritBatch!, batchNumber: value}})
  }

  /**
   * Updates supplier
   */
  private onSupplierChange = async (e: any, { value }: InputOnChangeData) => {
    this.setState({gritBatch: {...this.state.gritBatch!, supplier: value}})
  }

  /**
   * Updates delivery date
   */
  private onDeliveryDateChange = async (e: any, { value }: InputOnChangeData) => {
    const date =  moment(value as any, "DD.MM.YYYY").toDate();
    this.setState({gritBatch: {...this.state.gritBatch!, deliveryDate: date}})
  }

  /**
   * Updates amount
   */
  private onAmountChange = async (e: any, { value }: InputOnChangeData) => {
    this.setState({gritBatch: {...this.state.gritBatch!, amount: Number.parseFloat(value)}})
  }

}

/**
 * Redux mapper for mapping store state to component props
 *
 * @param state store state
 */
export function mapStateToProps(state: StoreState) {
  return {
    seedBatches: state.seedBatches,
    seedBatch: state.seedBatch,
    treeSpecies: state.treeSpecies,
    facility: state.facility
  };
}
/**
 * Redux mapper for mapping component dispatches
 *
 * @param dispatch dispatch method
 */
export function mapDispatchToProps(dispatch: Dispatch<actions.AppAction>) {
  return {
    onGritBatchSelected: (gritBatch: GritBatch) => dispatch(actions.gritBatchSelected(gritBatch)),
    onGritBatchDeleted: (gritBatchId: string) => dispatch(actions.gritBatchDeleted(gritBatchId)),
    onError: (error: ErrorMessage | undefined) => dispatch(actions.onErrorOccurred(error))
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(EditGritBatch);